/** @jsx jsx */
import { jsx, ThemeProvider } from "theme-ui";
import useMyBoolean from "sites-common/hooks/useMyBoolean";
import { DefaultButton } from "office-ui-fabric-react";
import getMandatoryEnv from "sites-common/utils/getMandatoryEnv";
import { Modal } from "../components/Modal";
import TheAvatar from "./TheAvatar";
import ensureSignedInSilent from "./ensureSignedInSilent";
import SignOutButton from "./SignOutButton";
import useAuth from "./useAuth";

const colorKeys = [
  "background",
  "text",
  "primary",
  "secondary",
  "errortext",
  "errorbg",
  "muted",
  "highlight",
  "background2",
];

const decodeColors = (colorString) => {
  const ret = {};
  colorString
    .split(":")
    .filter((x, xidx) => xidx < colorKeys.length)
    .forEach((x, xidx) => {
      ret[colorKeys[xidx]] = `#${x}`;
    });
  return ret;
};

const colors = decodeColors(
  `ffffff:000000:228b22:006400:ba0000:fed4d4:f6f6f6:efeffe:f0f0f0`
);
const Avatar = ensureSignedInSilent(({ avatarSize = 36 }) => {
  const { srcmProfile } = useAuth();
  const { photoUrl, name, isPrefect, email, mobile } = srcmProfile;
  const initials = name.substr(0, 1).replace(" ", "@");

  const [show, { setTrue, setFalse }] = useMyBoolean(false);

  const [showProfile] = useMyBoolean(false);

  const { profileSiteUrl } = getMandatoryEnv(["profileSiteUrl"]);

  return (
    <ThemeProvider theme={{ colors }}>
      <div>
        <div onKeyDown={setTrue} onClick={setTrue} role="button" tabIndex="0">
          <TheAvatar src={photoUrl} initials={initials} size={avatarSize} />
        </div>
        {show && (
          <Modal
            handleClose={setFalse}
            showCloseBtn={false}
            position={showProfile ? "right" : "top-right"}
          >
            {!showProfile && (
              <table>
                <tbody>
                  <tr>
                    <td>
                      <TheAvatar src={photoUrl} initials={initials} size={54} />
                    </td>
                    <td style={{ paddingLeft: "10px" }}>
                      <div
                        style={{
                          fontSize: "16px",
                          fontWeight: "700",
                          color: "black",
                        }}
                      >
                        {name}
                      </div>
                      <div style={{ fontSize: "14px", color: "black" }}>
                        {email}
                      </div>
                      <div style={{ fontSize: "14px", color: "black" }}>
                        {mobile}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td />
                    <td style={{ paddingLeft: "10px" }}>
                      <div style={{ fontSize: "12px", color: "black" }}>
                        {isPrefect ? "Preceptor" : ""}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2} style={{ paddingTop: "10px" }}>
                      <DefaultButton
                        text="My Profile"
                        target="_blank"
                        href={profileSiteUrl}
                      />
                      <SignOutButton />
                    </td>
                  </tr>
                </tbody>
              </table>
            )}
          </Modal>
        )}
      </div>
    </ThemeProvider>
  );
});

export default Avatar;
